// Greek

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `ανοικτή έως ${date}` : ''),
    },
    interview: {
      title: 'Απάντηση στη συνέντευξη μέσω βίντεο',
      submit: 'Αποστολή απαντήσεων και ολοκλήρωση συνέντευξης',
      continueLater: 'Συνέχεια αργότερα',
      startInterview: 'Έναρξη συνέντευξης',
      duplicateError: 'Έχετε ήδη συμμετάσχει σε αυτή τη συνέντευξη. Έχετε λάβει email από τη διεύθυνση invitations@recright.com με τον σύνδεσμο που μπορείτε να χρησιμοποιήσετε για να συνεχίσετε τη συνέντευξη.',
      confirmSubmitHeader: 'Δεν έχετε απαντήσει σε όλες τις ερωτήσεις της συνέντευξης',
      confirmSubmitContent: 'Θέλετε πραγματικά να τερματίσετε τη συνέντευξη;',
      confirmSubmitContentWarning: 'Μετά δεν θα μπορείτε να συμπληρώσετε τις απαντήσεις σας.',
      submitInterviewHeader: 'Υποβολή των απαντήσεων της συνέντευξής σας',
      submitInterviewContent: 'Σίγουρα θέλετε να υποβάλετε τη συνέντευξή σας;',
      confirmSubmitButton: 'Αποστολή απαντήσεων και ολοκλήρωση συνέντευξης',
      preview: 'Μπορείτε να δείτε τις βιντεο-ερωτήσεις εδώ.',
      requiredQuestionsNotAnswered: 'Παρακαλούμε απαντήστε σε όλες τις υποχρεωτικές ερωτήσεις πριν από την υποβολή.',

      withdrawLink: 'Δεν σας ενδιαφέρει πια αυτή η θέση; Πατήστε εδώ για να αποσυρθείτε από τη διαδικασία.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Όνομα',
      city: 'Τόπος κατοικίας',
      email: 'Email',
      phone: 'Τηλέφωνο',
      link: 'Σύνδεσμος',
      legendBasicInfo: 'Βασικές πληροφορίες',
      placeholderName: 'Εισαγωγή ονόματος',
      placeholderEmail: 'Εισαγωγή email',
      placeholderPhone: 'Εισαγωγή αριθμού τηλεφώνου',
      placeholderCity: 'Εισαγωγή τρέχουσας πόλης κατοικίας',
      placeholderLink: 'Προσθήκη συνδέσμου, π.χ. προφίλ στο LinkedIn.',
      legendAttachments: 'Επισυνάψεις',
      legendAdditionalFields: 'Πρόσθετες πληροφορίες',
      required: 'Τα πεδία που επισημαίνονται με *αστερίσκο είναι υποχρεωτικά.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Αρχείο ήχου',
        video: 'Βίντεο',
        yes: 'Ναι',
        no: 'Όχι',
        supported: 'Υποστηρίζεται',
        quality: 'Ποιότητα',
        header: 'Έλεγχος σύνδεσης δικτύου και συσκευής',
        description: 'Τώρα θα πραγματοποιήσουμε έναν έλεγχο, για να βεβαιωθούμε ότι η σύνδεση δικτύου σας και το λογισμικό που απαιτείται για τη συνέντευξη (κάμερα και τηλέφωνο) λειτουργούν κανονικά. Όταν σας ζητηθεί, επιτρέψτε στον έλεγχο τη πρόσβαση στη κάμερα και το μικρόφωνό σας και βεβαιωθείτε ότι η κάμερά σας δεν είναι καλυμμένη. Ο έλεγχος θα διαρκέσει περίπου 30 δευτερόλεπτα. Σας συνιστούμε να μιλάτε κατά τη διάρκεια διεξαγωγής του ελέγχου του λογισμικού.',
        inProgress: 'Έλεγχος σε εξέλιξη...',
        networkTestResults: 'Αποτελέσματα ελέγχου δικτύου',
        qualityTestResults: 'Αποτελέσματα ελέγχου ποιότητας',
        testPassedQuality: 'Ο έλεγχος ποιότητας ολοκληρώθηκε επιτυχώς',
        testFailedQuality: 'Ανεπιτυχής έλεγχος ποιότητας',
        testPassedNetwork: 'Επιτυχής έλεγχος δικτύου',
        testFailedNetwork: 'Ο έλεγχος δικτύου δεν ήταν επιτυχής',
        startTest: 'Έναρξη ελέγχου',
        startInterview: 'Έναρξη συνέντευξης',
        testAgain: 'Επανάληψη ελέγχου',
        confirmWarning: 'Μόλις ξεκινήσετε τη συνέντευξη μέσω βίντεο, θα μεταφερθείτε αυτομάτως στην πρώτη ερώτηση. Αφού την διαβάσετε, θα περάσετε στο στάδιο της προετοιμασίας.',
        confirmTitle: 'Η συνέντευξή σας πρόκειται να ξεκινήσει σε λίγο',
        confirmText: 'Θα έχετε στη διάθεσή σας λίγο χρόνο, για να προετοιμάσετε την απάντησή σας πριν από κάθε ερώτηση. Μετά το στάδιο της προετοιμασίας, θα έχετε στη διάθεσή σας προκαθορισμένο χρόνο, για να απαντήσετε στην ερώτηση. Λάβετε υπόψη ότι μπορείτε να υποβάλετε την απάντησή σας, όποτε είστε έτοιμοι, ακόμη και πριν ολοκληρωθεί ο προκαθορισμένος χρόνος για την υποβολή της απάντησής σας.',
        confirmText2: 'Κάθε φορά που υποβάλλετε την απάντησή σας, θα μεταφέρεστε στην επόμενη ερώτηση, μέχρι να απαντήσετε σε όλες τις ερωτήσεις.',
        confirmText3:
          'Σημειώστε ότι μετά την καταγραφή της απάντησής σας σε μια ερώτηση θα έχετε περιθώριο 30 δευτερολέπτων να υποβάλετε νέα απάντηση, αν επιτρέπεται η εκ νέου υποβολή απάντησης για την ερώτηση. Εάν δεν ξεκινήσετε την υποβολή νέας απάντησης εντός του περιθωρίου των 30 δευτερολέπτων, η τρέχουσα απάντησή σας θα υποβληθεί αυτόματα και θα οδηγηθείτε στην επόμενη ερώτηση.',
        goodLuck: 'Πάρτε μια βαθιά ανάσα και όλα θα πάνε καλά. Καλή επιτυχία!',
        qualityRating: {
          excellent: 'Εξαιρετική',
          good: 'Καλή',
          fair: 'Ικανοποιητική',
          poor: 'Ανεπαρκής',
          bad: 'Κακή',
        },
      },
      questionAnswerView: {
        title: title => `Απαντήστε στη συνέντευξη ${title}`,
        question: 'Ερώτηση',
        submitAndNext: 'Υποβολή & Επόμενη',
        submitSuccess: 'Το βίντεο υποβλήθηκε επιτυχώς!',
        skipText: 'Έναρξη εγγραφής',
        stop: 'Διακοπή',
        submitAndFinish: 'Υποβολή & Ολοκλήρωση της συνέντευξης',
        retake: 'Επανάληψη',
        take: 'Λήψη',
        takesLeft: 'Εναπομείνασες λήψεις',
        skipTextQuestion: 'Έτοιμοι; Προχωρώ',
        retakeConfirmTitle: 'Σίγουρα θέλετε να υποβάλετε νέα απάντησή σε αυτή την ερώτηση;',
        retakeConfirmSubmit: 'Ναι, να ξεκινήσει η υποβολή νέας απάντησης',
        submitInfoForward: 'Αυτόματη υποβολή της τρέχουσας απάντησής σας και συνέχεια σε',
        submitInfoForward2: 'δευτερόλεπτα',
        nonAnswerableText: 'Δεν χρειάζεται να απαντήσετε σε αυτό το μήνυμα. Μετά από αυτό το μήνυμα, θα μεταφερθείτε απευθείας στην επόμενη ερώτηση.',
        nonAnswerableVideo: 'Δεν χρειάζεται να απαντήσετε σε αυτό το βίντεο. Μετά από αυτό το βίντεο, θα μεταφερθείτε απευθείας στην επόμενη ερώτηση.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Έχετε ${answerMinutes} λεπτά και ${answerSeconds} δευτερόλεπτα για να απαντήσετε στην ερώτηση.`,
      },
      publisher: {
        toNextQuestion: timer => `Θα μεταφερθείτε στην επόμενη ερώτηση σε ${timer}`,
        recordingStarts: timer => `Η εγγραφή θα ξεκινήσει σε ${timer}`,
      },
      errors: {
        tooManyConnections: 'Αυτή η σύνδεση έκλεισε, επειδή ήδη έχετε μια σύνδεση ανοιχτή σε άλλη καρτέλα ή παράθυρο.',
        unsupportedBrowser: 'Δυστυχώς, η λειτουργία αυτή δεν υποστηρίζεται από το πρόγραμμα περιήγησής σας. Χρησιμοποιήστε ένα διαφορετικό πρόγραμμα περιήγησης.',
        networkError: 'Χωρίς σύνδεση στο διαδίκτυο.',
        reconnecting: 'Η σύνδεση διακόπηκε. Δοκιμάστε να συνδεθείτε ξανά.',
        generalError: 'Παρουσιάστηκε κάποιο σφάλμα. Ανανεώστε τη σελίδα και δοκιμάστε ξανά.',
        allowMediaDevicesError: 'Η λειτουργία αυτή δεν κατάφερε να εντοπίσει τις συσκευές πολυμέσων (κάμερα ή μικρόφωνο). Βεβαιωθείτε ότι έχετε επιτρέψει στο πρόγραμμα περιήγησης να χρησιμοποιήσει την κάμερα και το μικρόφωνό σας.',
        noAvailableDevicesError: 'Δεν ήταν δυνατή η εύρεση κάμερας ή μικροφώνου.',
        initPublisherError: 'Η λειτουργία απέτυχε λόγω σφάλματος. Βεβαιωθείτε ότι έχετε επιτρέψει στο πρόγραμμα περιήγησης να χρησιμοποιεί την κάμερα και το μικρόφωνό σας και ότι δεν χρησιμοποιούνται από άλλη εφαρμογή και προσπαθήστε ξανά.',
      },
      browserInfo: {
        browserSupportTitle: 'Υποστηριζόμενα προγράμματα περιήγησης',
        supportedBrowsers: 'Ο έλεγχος και η συνέντευξη υποστηρίζουν τις τελευταίες εκδόσεις των προγραμμάτων περιήγησης Chrome, Firefox, Safari και Edge.',
        mobileSupported: 'Υποστηριζόμενα προγράμματα περιήγησης σε κινητές συσκευές',
        android: 'Android: Google Chrome (τελευταία έκδοση), Firefox (τελευταία έκδοση)',
        iOS: 'iOS: Safari (τελευταία έκδοση)',
        latestVersion: '. Βεβαιωθείτε ότι χρησιμοποιείτε την τελευταία έκδοση του προγράμματος περιήγησης, ώστε να διασφαλίσετε ότι όλα λειτουργούν ομαλά.',
        freezeInstruction: 'Αν η εγγραφή βίντεο δεν ξεκινήσει ή η οθόνη εγγραφής παραμένει μαύρη, ανανεώστε τη σελίδα.',
        unsupportedOnIos: 'Φαίνεται ότι χρησιμοποιείτε ένα πρόγραμμα περιήγησης που δεν υποστηρίζεται σε συσκευή iOS. Χρησιμοποιήστε το Safari.',
        ieUnsupported: 'Φαίνεται ότι χρησιμοποιείτε τον Internet Explorer. Δυστυχώς, ο Internet Explorer δεν είναι υποστηριζόμενο πρόγραμμα περιήγησης για αυτόν τον έλεγχο ή τη συνέντευξη. Χρησιμοποιήστε ένα διαφορετικό πρόγραμμα περιήγησης.',
        qualityTestNotSupported: 'Δυστυχώς ο έλεγχος του λογισμικού δεν υποστηρίζεται από το πρόγραμμα περιήγησης που χρησιμοποιείτε. Μπορείτε να προχωρήσετε στη συνέντευξη χωρίς να πραγματοποιήσετε τον έλεγχο ποιότητας ήχου και βίντεο, ή εναλλακτικά, χρησιμοποιήστε ένα διαφορετικό πρόγραμμα περιήγησης.',
      },
      reconnectSuccess: 'Επανασυνδεθήκατε επιτυχώς!',
      continue: 'Συνεχίστε',
    },

    withdraw: {
      title: 'Δεν σας ενδιαφέρει πια αυτή η θέση;',
      description: 'Αποσυρθείτε από τη διαδικασία πρόσληψης.',
      buttonText: 'Απόσυρση από τη διαδικασία πρόσληψης',
      thankYouTitle: 'Ευχαριστούμε!',
      thankYouText: 'Μόλις έχετε ενημερώσει τους υπεύθυνους πρόσληψης ότι δεν ενδιαφέρεστε πια για τη θέση.',
      confirm: 'Θέλετε σίγουρα να αποσυρθείτε από τη διαδικασία πρόσληψης; Εάν αποσυρθείτε, δεν θα έχετε τη δυνατότητα πλέον να απαντήσετε ούτε σε αυτήν ούτε σε οποιαδήποτε άλλη συνέντευξη σχετικά με αυτή τη θέση.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Υποβολή',
      continue: 'Συνέχεια',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Σας ευχαριστούμε για την αποστολή της απάντησής σας μέσω βίντεο! Θα επικοινωνήσουμε μαζί σας σύντομα!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Σας ευχαριστούμε για τη συμμετοχή σας στη συνέντευξη!',
      reopenDescription: 'Εάν κλείσατε αυτή τη συνέντευξη κατά λάθος, μην ανησυχείτε! Μπορείτε να επιστρέψετε στη συνέντευξη, πατώντας το παρακάτω κουμπί!',
      reopenButtonText: 'Επιστροφή στη συνέντευξη',
      description1: 'Υπέροχα! Έχετε απαντήσει σε όλες τις ερωτήσεις και οι απαντήσεις σας έχουν σταλεί στον παραλήπτη.',
      descriptionsupport: mailto => `Εάν κλείσατε αυτή τη συνέντευξη εκ παραδρομής, παρακαλούμε επικοινωνήστε με το τμήμα εξυπηρέτησης πελατών, στέλνοντας email στη διεύθυνση ${mailto} και θα ενεργοποιήσουμε ξανά τη συνέντευξή σας.`,
      descriptionfeedback: 'Η εμπειρία σας είναι σημαντική για εμάς! Πώς σας φάνηκε η διαδικασία απάντησης ερωτήσεων σε συνέντευξη μέσω βίντεο; Πώς θα μπορούσε να βελτιωθεί η υπηρεσία μας; Εισάγετε τα σχόλιά σας εδώ.\n',
      feedbackbutton: 'Η γνώμη σας μας ενδιαφέρει!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Προσωπικό μήνυμα',
    },

    closed: {
      title: 'Η συνέντευξη έχει ολοκληρωθεί ή η συνέντευξη τελείωσε',
      description: 'Η συνέντευξη μέσω βίντεο στην οποία προσκληθήκατε έχει ήδη τελειώσει ή έχετε ολοκληρώσει την υποβολή της συμμετοχής σας.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Η συνέντευξή σας τώρα έχει αποθηκευτεί!',
      description: 'Όταν θα θέλετε να συνεχίσετε τη συνέντευξη μέσω βίντεο, χρησιμοποιήστε τον σύνδεσμο που λάβατε νωρίτερα στο email σας. Οι απαντήσεις που έχουν ήδη μαγνητοσκοπηθεί, θα είναι διαθέσιμες όταν επιστρέψετε! Καλή τύχη στην αναζήτηση εργασίας!',
      remember: 'Θυμηθείτε να στείλετε τις απαντήσεις στην εταιρεία πρόσληψης, μόλις απαντήσετε σε όλες τις ερωτήσεις της συνέντευξης.',
      deleteHistory: 'Εάν η συνέντευξη μέσω βίντεο πραγματοποιείται σε δημόσιο υπολογιστή, παρακαλούμε θυμηθείτε να διαγράψετε το ιστορικό περιήγησής σας. Με τον τρόπο αυτό, η συνέντευξή σας θα είναι ασφαλής.',
    },
    unpublished: {
      title: 'Η συνέντευξη δεν είναι ακόμη διαθέσιμη',
      publishTime: publishTime => `Η συνέντευξη θα είναι διαθέσιμη στις ${publishTime}`,
    },
  },
}
